import React from 'react';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';
import { SignupCallout } from '@gik/auth';
import { ISignupCalloutProps } from '@gik/auth/components/Signup/SignupCallout';
import { useBemCN } from '@gik/core/utils/bemBlock';

export interface ISignupCalloutCalendarProps {
  recipientName: string;
}

export default function SignupCalloutCalendar({ recipientName }: ISignupCalloutCalendarProps) {
  const bem = useBemCN('signup-callout-calendar');

  const values: ISignupCalloutProps = {
    mdBackgroundImageUrl: `${getAssetsUrl()}auth/img/SignupCalloutCalendar/calendar.png`,
    mdDownBackgroundImageUrl: `${getAssetsUrl()}auth/img/SignupCalloutCalendar/calendar-mobile.png`,
    title: 'Sign up to help',
    subtitle: `with meals, rides, pet care, and more. For free! Support <span class="tw-font-bold">${recipientName}</span> today.`,
    imageUrl: `${getAssetsUrl()}auth/img/SignupCalloutCalendar/calendar-example.svg`,
    imageAlt: 'Care calendar example',
    ...bem(),
  };

  return <SignupCallout {...values} />;
}
